import { useEffect } from "react";
import { ContentArticle } from './types';

interface PageProps {
  article: ContentArticle;
}

export const PageBody = (props: PageProps) => {
  const { article } = props;

  return article.body;
};

export const Page = (props: PageProps) => {
  const { article } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [article]);

  return (
    <>
      <div>
        <div className={`h-[300px] flex items-end rounded-lg relative`}>
          <img className='absolute' src={article.banner} alt={article.title} />
          <h1 className='p-4 bg-slate-800 bg-opacity-80 z-10'>{article.title}</h1>
        </div>
      </div>
      <div className='p-4 flex flex-col gap-4'>
        <PageBody article={article} />
      </div>
    </>
  );
};
